import { render, staticRenderFns } from "./grccms_slider.vue?vue&type=template&id=b630bf90&scoped=true&"
import script from "./grccms_slider.vue?vue&type=script&lang=js&"
export * from "./grccms_slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b630bf90",
  null
  
)

export default component.exports